import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import SearchModal from '../Search/SearchModal';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header onSearchClick={() => setIsSearchOpen(true)} />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <SearchModal 
        isOpen={isSearchOpen} 
        onClose={() => setIsSearchOpen(false)} 
      />
    </div>
  );
};

export default Layout;